export default {
  methods: {
    placechange(event) {
      const locationObj = {
        address: "",
        data: {},
        Lat: "",
        Lng: "",
      };
      const componentForm = {
        street_number: "short_name",
        route: "long_name",
        locality: "long_name",
        administrative_area_level_1: "long_name",
        country: "long_name",
        postal_code: "long_name",
        sublocality_level_1: "long_name",
      };

      if (!event) {
        this.$store.dispatch("item/setItemCatalogLocation", locationObj);
        return locationObj;
      }

      if (event.formatted_address) {
        locationObj.address = event.formatted_address;
      }
      if (event.geometry && event.geometry.location) {
        locationObj.Lat = event.geometry.location.lat();
        locationObj.Lng = event.geometry.location.lng();
      }
      const data = {};
      const addressComponents = Array.isArray(event.address_components)
        ? event.address_components
        : [];
      for (let i = 0; i < addressComponents.length; i++) {
        const addressType = addressComponents[i].types[0];
        if (componentForm[addressType]) {
          data[addressType] = addressComponents[i][componentForm[addressType]];
        }
      }
      if (data) {
        if (data.locality) {
          locationObj.data.City = data.locality;
        }
        if (data.country) {
          locationObj.data.Country = data.country;
        }
        if (data.administrative_area_level_1) {
          locationObj.data.State = data.administrative_area_level_1;
        }
        if (data.sublocality_level_1) {
          locationObj.data.Area = data.sublocality_level_1;
        }
        if (data.postal_code) {
          locationObj.data.zip = data.postal_code;
        }
      }
      this.$store.dispatch("item/setItemCatalogLocation", locationObj);
      return locationObj;
    },
  },
};
